// extracted by mini-css-extract-plugin
module.exports = {"ad":"ad-1L1eVP3h","box":"box-gtreT9_H","footer":"footer-3DRIhhxl"};